<template>
  <div>
    <section-title
      content="Información del Portal Público de Proveedores"
      :has-line="true"
    />
    <div class="bg-secondary-3 d-flex flex-column pb-4">
      <div class="question-element">
        <div class="item-pane">
          <div class="question-line py-4">
            <p :id="`pName-1`" class="mb-0 pr-2">
              ¿Desea que este lugar de servicios esté disponible en el listado
              de Proveedores activos de Remedio Provisional en el Portal de
              Educación Especial?
            </p>
          </div>
          <div class="align-items-start d-flex p-0 custom-radio-container">
            <radio-button
              ref="radioButtonRef"
              :change-event="onChange"
              class="radio-button-container"
              :name="'rbQuestion'"
              :question-lists="options"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="model.locationAvailableFlag"
      class="bg-secondary-3 rounded px-4 pb-4"
    >
      <div class="col-md-12 text-gray mb-3">
        Seleccione la(s) disciplina(s) asociada(s) a este lugar de servicio
      </div>
      <div class="col-md-12">
        <custom-result-not-found
          v-if="!associatedDisciplines.length"
          text="No cuenta con información disponible en sistema."
        />
        <div v-else class="col-md-12">
          <div
            class="
              col-12
              overflow-auto
              max-height-100
              border
              rounded
              bg-white
              p-3
            "
          >
            <div class="mt-1 disciplines-container">
              <div
                v-for="discipline in associatedDisciplines"
                :key="discipline.id"
              >
                <check-box
                  v-model="discipline.selected"
                  class="discipline-checkbox"
                  :text="discipline.name"
                  @input="onCheckDiscipline($event, discipline)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error
      v-if="showError"
      class="col-12 mx-3 mb-2"
      :message="'Favor marcar Si o No.'"
      variant="no-border"
    />
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CheckBox from 'CheckBox';
import RadioButton from '@/components/common/CustomRadioButton';
import Error from 'custom-error';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'LocationServicePublicPortalInfo',
  components: {
    SectionTitle,
    CheckBox,
    RadioButton,
    Error,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    associatedDisciplines: {
      type: Array,
      default: () => [],
    },
    showError: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    options() {
      return {
        invalid: false,
        options: [
          {
            id: true,
            label: 'Si',
            check: this.model.locationAvailableFlag === true,
            disabled: false,
          },
          {
            id: false,
            label: 'No',
            check: this.model.locationAvailableFlag === false,
            disabled: false,
          },
        ],
      };
    },
  },
  async mounted() {},
  methods: {
    onChange(item) {
      this.model.locationAvailableFlag = item.id;
      this.$emit('update:showError', false);
    },
    onCheckDiscipline(checked, discipline) {
      discipline.selected = checked;
    },
  },
  watch: {
    'value.locationAvailableFlag': {
      immediate: true,
      handler: function(value) {
        if (value == null) return;
        if (this.selectedOption) return;
        this.selectedOption = this.options.options.find((y) => y.id === value);
        this.$refs.radioButtonRef.Change(this.selectedOption);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.question {
  align-content: space-between;
}
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 20px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
  margin-right: 40px;
  margin-left: 40px;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.question-line p >>> p {
  margin-bottom: 0px !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
.license-label {
  color: map-get($colors, 'gray-7');
  font-weight: bold;
}
.disciplines-container .discipline-checkbox {
  font-weight: normal;
  color: map-get($colors, 'gray-6');
}
.div-error {
  background: #feeaea;
  padding: 20px;
}
.div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
</style>
